import { render } from "./debug.vue?vue&type=template&id=07e20cd1&scoped=true"
import script from "./debug.vue?vue&type=script&lang=js"
export * from "./debug.vue?vue&type=script&lang=js"

import "./debug.vue?vue&type=style&index=0&id=07e20cd1&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e20cd1"]])

export default __exports__